/**
 * Pick a root directory for “folder as workspace” (File System Access API).
 */

export async function pickWorkspaceDirectory(): Promise<FileSystemDirectoryHandle | null> {
  if (!("showDirectoryPicker" in window)) {
    void alert(
      "Open Folder requires a browser with the File System Access API (for example Chrome or Edge).",
    );
    return null;
  }
  try {
    return await window.showDirectoryPicker({ mode: "readwrite" });
  } catch (e) {
    if ((e as DOMException).name === "AbortError") return null;
    throw e;
  }
}
